module.exports = __webpack_public_path__ + "img/drachenmakiganz.9b0d5db7.jpg";